import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import {
  Table,
  TableBody,
  FormControl,
  TableRow,
  TableCell,
  Paper,
  makeStyles,
  Button,
  Box,
  Select,
  MenuItem,
  Tooltip,
  Grid,
  TableContainer,
  InputAdornment,
  Popover,
  TextField,
  Typography,
  Menu,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  useTheme,
} from "@material-ui/core";
import Config from "../../config/config";
import { Link as RouterLink } from 'react-router-dom'; // Alias for React Router's Link
import MuiLink from '@mui/material/Link'; // MUI's Link component
// import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import { Pagination } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import { getSignee } from "../../store/action";
import history from "../../utils/HistoryUtils";
import FilterListIcon from "@material-ui/icons/FilterList";
import axios from "axios";
import apiConfigs from "../../config/config";
import { getStaffDetail } from "../../store/action/staff/staffAction";
import { getSpecShiftCreate } from "../../store/action/specialities/specialitiesAction";
import {
  createFilter,
  deleteFilter,
} from "../../store/action/booking/bookingAction";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { getFilterData, getCategories } from "../../store/action/signee/signeeAction";
import EnhancedTableHead from "./EnhancedTableHead";
import { headCells } from "./Headcells";
import { useGooglePlaceAutoCompleteForCandidate } from "../../components/GoogleAPI/google_place_autocomplete";
import Loading from "../../components/Loading/Loading";
import TruncateText from "../../components/TruncateText";
import EnhancedTableToolbar from "../../components/EnhancedTableToolbar";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TablePaginationControls from "../../components/TablePaginationControls";
import { ThemeContext } from "../../App";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    // overflowX: "auto",
    background: theme.palette.background.main,
    padding: 24,
    marginBottom: 0,
  },

  container: {
    // marginTop: "15px",
    overflow: "auto",
    maxHeight: "calc(100vh - 260px)",
  },
  cellId: {
    color: theme.palette.text.primary
  },
  dialogWidth: { width: "100%" },

}));

const ViewSignee = ({ match }) => {
  const theme = useTheme();
  const classes = useStyle();
  const dispatch = useDispatch();
  const { getSigneeItem, loading, getVCFilterDataSuccess, getCategoriesItem } = useSelector(
    (state) => state.signee
  );
  const [page, setPage] = useState(1);
  const [searchPage, setSearchPage] = useState(1);
  const [perPage, setPerPage] = useState(15);
  const [categories, setCategories] = useState([]);
  const [speciality, setSpeciality] = useState([]);
  const [specError, setSpecError] = useState(false);
  const [staff, setStaff] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("users.first_name");
  const expiryColorStyles = {
    RED: {
      backgroundColor: "#ffcccc",
      border: "1px solid #ff0000",
      color: "#a10000",
    },
    ORANGE: {
      backgroundColor: "#ffe0b3",
      border: "1px solid #ff9900",
      color: "#cc6600",
    },
    GREEN: {
      backgroundColor: "#d4f5d4",
      border: "1px solid #28a745",
      color: "#1d7d33",
    },
    WHITE: {
      backgroundColor: "#ffffff",
      border: "1px solid #cccccc",
      color: "#666666",
    },
  };

  let staffDetail = JSON.parse(localStorage.getItem("staffDetail"));

  staffDetail = staffDetail && staffDetail.replace(/['"]+/g, "");

  const [searchData, setSearchData] = React.useState({
    search: "",
    new_status: "",
    specialty: "",
    postcode: "",
    consultants: "",
    module_name: "candidates",
    proximity: "",
    start_date: "",
    end_date: "",
    categoryItem: ""
  });

  const [visibleColumns, setVisibleColumns] = useState(
    headCells[0].filter(col => col?.display !== false).map((col) => col.id)
  );

  const handleColumnToggle = (columnId) => {
    setVisibleColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId)
        : [...prev, columnId]
    );
  };

  const loginUserInfo = JSON.parse(
    window.localStorage.getItem("loginUserInfo")
  );

  const address1Ref = useRef();
  const googleAutoCompleteSvc = useGooglePlaceAutoCompleteForCandidate();
  let autoComplete = "";

  const handleAddressSelect = async () => {
    let addressObj = await googleAutoCompleteSvc.getFullAddress(autoComplete);
    setSearchData((prevData) => ({
      ...prevData,
      postcode: addressObj.address_line_1,
      latitude: addressObj.latitude,
      longitude: addressObj.longitude,
    }));
  };

  const handleChange = (event, newValue, value) => {
    async function loadGoogleMaps() {
      autoComplete = await googleAutoCompleteSvc.initAutoComplete(
        address1Ref.current,
        handleAddressSelect
      );
    }
    loadGoogleMaps();
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleAutoComplete = (event, newValue, value) => {
    if (value == "selectOption") {
      let numbers = newValue.map(item => item.id);
      setSearchData((searchData) => ({ ...searchData, categoryItem: numbers }));
    }
  }

  const handleSearchChange = (event) => {
    const d1 = event.target.value;
    if (d1) {
      setTimeout(
        getSigneeList(
          searchPage,
          perPage,
          d1,
          searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.new_status,
          searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty,
          searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode,
          searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants,
          "",
          "",
          searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity,
          searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude,
          searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude,
          searchData?.start_date ? moment(searchData?.start_date).format("YYYY-MM-DD") : "",
          searchData?.end_date ? moment(searchData?.end_date).format("YYYY-MM-DD") : "",
          searchData?.categoryItem ? searchData?.categoryItem.join(",") : [],
        ),
        100
      );
    } else {
      setTimeout(
        getSigneeList(
          page,
          perPage,
          "",
          searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.new_status,
          searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty,
          searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode,
          searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants,
          "",
          "",
          searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity,
          searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude,
          searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude,
          searchData?.start_date ? moment(searchData?.start_date).format("YYYY-MM-DD") : "",
          searchData?.end_date ? moment(searchData?.end_date).format("YYYY-MM-DD") : "",
          searchData?.categoryItem ? searchData?.categoryItem.join(",") : [],
        ),
        100
      );
      setSearchPage(1);
    }
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleMenu = (event) => {
    if (
      searchData.search === "" &&
      searchData.new_status === "" &&
      searchData.specialty === "" &&
      searchData.postcode === "" &&
      searchData.consultants === "" &&
      searchData.start_date === "" &&
      searchData.end_date === ""
    ) {
      getFilterDataByModule();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClickSearch = (event, value) => {
    handleMenuClose(true);
    setTimeout(() => {
      getSigneeList(
        page,
        perPage,
        searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
        searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.new_status,
        searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty,
        searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode,
        searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants,
        "",
        "",
        searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity,
        searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude,
        searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude,
        searchData?.start_date ? moment(searchData?.start_date).format("YYYY-MM-DD") : "",
        searchData?.end_date ? moment(searchData?.end_date).format("YYYY-MM-DD") : "",
        searchData?.categoryItem ? searchData?.categoryItem.join(",") : [],
      )
    }
      , 1000
    )
    // Category set null after searching 
  };

  const getSigneeList = (
    pageNo = 1,
    perPage = 15,
    search = "",
    new_status = "",
    specialty = "",
    postcode = "",
    consultants = "",
    type = order,
    column_name = orderBy,
    proximity = "",
    latitude = "",
    longitude = "",
    startDate = "",
    endDate = "",
    categoryItem = ""
  ) => {
    dispatch(
      getSignee({
        pageNo,
        perPage,
        search,
        new_status,
        specialty,
        postcode,
        consultants,
        type,
        column_name,
        proximity,
        latitude,
        longitude,
        startDate,
        endDate,
        categoryItem
      })
    );
  };

  const getStaff = async () => {
    dispatch(
      getStaffDetail((result) => {
        if (result?.data) {
          setStaff(result);
        }
      })
    );
  };

  const getSpecialities = async () => {
    dispatch(
      getSpecShiftCreate((result) => {
        if (result?.status === true) {
          setSpeciality(result?.data);
        } else {
          setSpeciality([]);
        }
      })
    );
  };


  useEffect(() => {
    getSpecialities();
    getStaff();
    getFilterDataByModule();
  }, []);

  const onhandlClick = (id) => {
    history.push(`${match.url}/${id}/detail`);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
    getSigneeList(
      value,
      perPage,
      searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
      searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.new_status,
      searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty,
      searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode,
      searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants,
      order,
      orderBy,
      searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity,
      searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude,
      searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude,
      searchData?.start_date ? moment(searchData?.start_date).format('YYYY-MM-DD') : getVCFilterDataSuccess?.data?.start_date,
      searchData?.end_date ? moment(searchData?.end_date).format('YYYY-MM-DD') : getVCFilterDataSuccess?.data?.end_date,
      searchData?.categoryItem ? searchData?.categoryItem.join(",") : [],
    );
  };

  const handlePerPageChange = (event) => {
    const newPerPage = event.target.value;
    setPerPage(newPerPage);
    setPage(1); // Reset to first page when changing items per page

    getSigneeList(
      1,
      newPerPage,
      searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
      searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.new_status,
      searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty,
      searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode,
      searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants,
      order,
      orderBy,
      searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity,
      searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude,
      searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude,
      searchData?.start_date ? moment(searchData?.start_date).format('YYYY-MM-DD') : getVCFilterDataSuccess?.data?.start_date,
      searchData?.end_date ? moment(searchData?.end_date).format('YYYY-MM-DD') : getVCFilterDataSuccess?.data?.end_date,
      searchData?.categoryItem ? searchData?.categoryItem.join(",") : [],
    );
  };

  const handleReset = () => {
    let data = {
      search: "",
      new_status: "",
      specialty: "",
      postcode: "",
      consultants: "",
      start_date: "",
      end_date: "",
      module_name: "candidates",
    };
    setSearchData(data);
    handleMenuClose(true);
    dispatch(deleteFilter(data, "candidates"));
    dispatch({ type: 'EMPTY_VC_FILTER_DATA' });
    getSigneeList(page, "", "")
  };

  const handleDownload = async (event, value) => {
    const loggedInUser = localStorage.getItem("token").replace(/['"]+/g, "");
    const new_status = searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.new_status;
    const postcode = searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode;
    const proximity = searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity;
    const consultants = searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants;
    const specialty = searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty;
    const search = searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search;
    const latitude = searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude;
    const longitude = searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude;

    await axios
      .get(
        `${apiConfigs.API_URL}api/organization/download-candidates-csv?search=${search || ""
        }&new_status=${new_status || ""}&postcode=${postcode || ""}&proximity=${proximity || ""
        }&consultantsId=${consultants || ""}&specialty=${specialty || ""}&latitude=${latitude || ""}&longitude=${longitude || ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${loggedInUser}`,
          },
        }
      )
      .then((response) => {
        const url = response.data.data;
        var link = document.createElement("a");
        link.download = "Candidate.csv";
        link.href = url;
        link.target = "_blank";
        link.click();
      })
      .catch((error) => {
        console.error("error: ", error);
      });
  };

  const getFilterDataByModule = () => {
    let data = {
      search: "",
      new_status: "",
      specialty: "",
      postcode: "",
      consultants: "",
      compliance: "",
      start_date: "",
      end_date: "",
      module_name: "candidates",
    };
    dispatch(getFilterData("candidates"));
    if (getVCFilterDataSuccess?.data) {
      if (getVCFilterDataSuccess?.data?.status !== "") {
        data.new_status = getVCFilterDataSuccess?.data?.new_status;
      }
      if (getVCFilterDataSuccess?.data?.specialty !== "") {
        data.specialty = getVCFilterDataSuccess?.data?.specialty;
      }
      if (getVCFilterDataSuccess?.data?.postcode !== "") {
        data.postcode = getVCFilterDataSuccess?.data?.postcode;
      }
      if (getVCFilterDataSuccess?.data?.consultants !== "") {
        // data.consultants = getVCFilterDataSuccess?.data?.consultants;
      }
      if (getVCFilterDataSuccess?.data?.start_date) {
        data.start_date = getVCFilterDataSuccess?.data?.start_date;
      }
      if (getVCFilterDataSuccess?.data?.end_date) {
        data.end_date = getVCFilterDataSuccess?.data?.end_date;
      }
      setSearchData(data);
    }
  };

  const handleClickSave = async () => {
    dispatch(createFilter(searchData, "candidates"));
    setPage(1);
    if (getVCFilterDataSuccess?.data?.end_date) {
      setSearchData({
        ...searchData,
        end_date: getVCFilterDataSuccess?.data?.end_date,
      });
    }

    let iStartDate = searchData?.start_date
      ? moment(searchData?.start_date).format("YYYY-MM-DD")
      : "";
    let sStartDate = getVCFilterDataSuccess?.data?.start_date
      ? moment(getVCFilterDataSuccess?.data?.start_date).format("YYYY-MM-DD")
      : "";
    iStartDate = iStartDate !== "" ? iStartDate : sStartDate;

    setSearchData({
      ...searchData,
      start_date: iStartDate,
    });
    let iEndDate = searchData?.end_date
      ? moment(searchData?.end_date).format("YYYY-MM-DD")
      : "";
    let sEndDate = getVCFilterDataSuccess?.data?.end_date
      ? moment(getVCFilterDataSuccess?.data?.end_date).format("YYYY-MM-DD")
      : "";

    iEndDate = iEndDate !== "" ? iEndDate : sEndDate;

    setSearchData({
      ...searchData,
      end_date: iEndDate,
    });

    getSigneeList(
      1,
      "",
      searchData?.search
        ? searchData?.search
        : getVCFilterDataSuccess?.data?.search,
      searchData?.new_status
        ? searchData?.new_status
        : getVCFilterDataSuccess?.data?.new_status,
      searchData?.specialty
        ? searchData?.specialty
        : getVCFilterDataSuccess?.data?.specialty,
      searchData?.postcode
        ? searchData?.postcode
        : getVCFilterDataSuccess?.data?.postcode,
      searchData?.consultants
        ? searchData?.consultants
        : getVCFilterDataSuccess?.data?.consultants,
      order,
      orderBy,
      searchData?.proximity
        ? searchData?.proximity
        : getVCFilterDataSuccess?.data?.proximity,
      searchData?.latitude
        ? searchData?.latitude
        : getVCFilterDataSuccess?.data?.latitude,
      searchData?.longitude
        ? searchData?.longitude
        : getVCFilterDataSuccess?.data?.longitude,
      searchData?.start_date ? moment(searchData?.start_date).format('YYYY-MM-DD')
        : getVCFilterDataSuccess?.data?.start_date,
      searchData?.end_date
        ? moment(searchData?.end_date).format('YYYY-MM-DD')
        : getVCFilterDataSuccess?.data?.end_date,
      searchData?.categoryItem
        ? searchData?.categoryItem.join(",")
        : [],
    );
    handleMenuClose(true);
  };

  const handleRequestSort = (
    property,
    setOrder,
    setOrderBy,
    orderBy,
    order
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    if (searchData || getVCFilterDataSuccess?.data) {
      getSigneeList(
        page,
        perPage,
        searchData?.search ? searchData?.search : getVCFilterDataSuccess?.data?.search,
        searchData?.new_status ? searchData?.new_status : getVCFilterDataSuccess?.data?.status,
        searchData?.specialty ? searchData?.specialty : getVCFilterDataSuccess?.data?.specialty,
        searchData?.postcode ? searchData?.postcode : getVCFilterDataSuccess?.data?.postcode,
        searchData?.consultants ? searchData?.consultants : getVCFilterDataSuccess?.data?.consultants,
        order,
        orderBy,
        searchData?.proximity ? searchData?.proximity : getVCFilterDataSuccess?.data?.proximity,
        searchData?.latitude ? searchData?.latitude : getVCFilterDataSuccess?.data?.latitude,
        searchData?.longitude ? searchData?.longitude : getVCFilterDataSuccess?.data?.longitude,
        searchData?.start_date ? moment(searchData?.start_date).format('YYYY-MM-DD') : getVCFilterDataSuccess?.data?.start_date,
        searchData?.end_date ? moment(searchData?.end_date).format('YYYY-MM-DD') : getVCFilterDataSuccess?.data?.end_date,
        searchData?.categoryItem ? searchData?.categoryItem.join(",") : [],
      );
    }
  }, [getVCFilterDataSuccess?.data, order, orderBy, page, perPage]);

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    if (getCategoriesItem?.length > 0) {
      setCategories(getCategoriesItem);
    }
  }, [getCategoriesItem]);

  const navigate = (url) => {
    history.push(url); // or history.replace('/dashboard');
  };
  const [customerCount, setCustomerCount] = useState([]);
  const handleCheckboxClick = (event, id) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      setCustomerCount((prev) => [...prev, id]); // append to existing array

    } else {
      setCustomerCount((prev) => prev.filter((item) => item !== id));
    }
  }

  const handleCheckboxAllClick = (event) => {
    const isChecked = event.target.checked;
    if (isChecked && getSigneeItem?.data?.data.length > 0) {
      const createArray = [];
      getSigneeItem?.data?.data.map((row, index) => {
        createArray.push(row.id);
      });
      setCustomerCount(createArray);
    } else {
      setCustomerCount([]);
    }
  };
  const [data, setData] = useState({
    subject: "",
    messageBody: "",
  });

  const [formError, setError] = useState([])
  const [modelOpen, setModelOpen] = useState(false);
  const handleClose1 = () => {
    setModelOpen(false);
    setCustomerCount([]);
    setData({ subject: "", messageBody: "" });
    setError([]);
  }

  const handleChanges = (event) => {

    if (event.target.value) {
      setError([]);
    } else {
      setError(`err_${event.target.name}`);
    }
    setData({ ...data, [event.target.name]: event.target.value });
  }
  const sendMessage = async (event) => {
    event.preventDefault();

    if (data.subject === "") {
      setError("err_subject");
      return;
    }
    if (data.messageBody === "") {
      setError("err_messageBody");
      return;
    }

    setError([]);
    const payload = { ...data, candidate_ids: customerCount };
    const token = localStorage.getItem("token").replace(/['"]+/g, "");

    try {
      await axios.post(`${Config.API_URL}api/organization/send-message-to-candidate`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      // Reset after successful request
      setCustomerCount([]);
      setData({ subject: "", messageBody: "" });
      handleClose1();
    } catch (error) {
      console.error(error);
      // Optionally show an error message or keep customerCount
      // setCustomerCount(payload.candidate_ids); 
    }
  };

  const { mode } = useContext(ThemeContext);
  useEffect(() => {
    document.documentElement.style.setProperty('--bg-color', theme.palette.grey[1000]);
    document.documentElement.style.setProperty('--sticky-header', theme.palette.thead);
    document.documentElement.style.setProperty('--sticky-odd', theme.palette.background.stickyOdd);
    document.documentElement.style.setProperty('--sticky-even', theme.palette.background.stickyEven);
  }, [mode]);

  const convertDateFormat = (dateString) => {
    const raw = dateString?.toString().trim() || "";
    // Parse with DD-MM-YYYY format
    const m = moment(raw, "DD-MM-YYYY", true);

    const isValid = m.isValid();
    const formatted = isValid ? m.format("DD MMM YYYY") : "-";
    return formatted;
  };
  return (
    <>

      {(loading && !openMenu) && <Loading open={loading} />}

      <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} mb={2}>
        {customerCount?.length > 0 ? <div >
          <Button
            color="primary"
            variant="contained"
            onClick={() => setModelOpen(true)}
            size="small"
          >
            <AddIcon className="mr-2" />
            Send Message
          </Button>
        </div> : <div></div>}
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            size="small"
            placeholder="Search now..."
            name="search"
            variant="outlined"
            onChange={handleSearchChange}
            onKeyPress={(e) => e.key === "Enter" && handleClickSearch()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon
                    style={{
                      color: "#856f6f", // Icon color
                      cursor: "pointer",
                    }}
                    onClick={handleClickSearch}
                  />
                </InputAdornment>
              ),
            }}
            className="modernSearchField"
          />

          <Tooltip title="Filters">
            <Button onClick={handleMenu}>
              <FilterListIcon />
            </Button>
          </Tooltip>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            open={openMenu}
            getContentAnchorEl={null}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            className="filterBookingSearch"

          >
            <Box className="customPopup" >
              <Grid container spacing={2}>
                {/* Row 1 */}
                <Grid item xs={4} md={4}>
                  {/* <FormControl fullWidth variant="outlined"> */}
                  <Autocomplete
                    id="status-select"
                    options={[
                      { value: "Active", label: "Active" },
                      { value: "Not active", label: "Not active" },
                      { value: "Pre reg", label: "Pre reg" },
                      { value: "New sign up", label: "New sign up" },
                      { value: "Archive", label: "Archive" },
                      { value: "Do not use", label: "Do not use" },
                    ]}
                    getOptionLabel={(option) => option.label}
                    value={
                      searchData?.new_status
                        ? { value: searchData.new_status, label: searchData.new_status }
                        : null
                    }
                    onChange={(event, newValue) => {
                      setSearchData({
                        ...searchData,
                        new_status: newValue ? newValue.value : "",
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Status" variant="outlined" />
                    )}
                  />
                  {/* </FormControl> */}
                </Grid>

                <Grid item xs={4} md={4}>
                  <TextField
                    fullWidth
                    label="Location (Post Code)"
                    variant="outlined"
                    name="postcode"
                    value={searchData?.postcode || ""}
                    onChange={handleChange}
                  />
                </Grid>

                <Grid item xs={4} md={4}>
                  <TextField
                    fullWidth
                    label="Proximity"
                    variant="outlined"
                    name="proximity"
                    value={searchData?.proximity || ""}
                    onChange={handleChange}
                  />
                </Grid>

                {/* Row 2 */}
                <Grid item xs={4} md={4}>
                  {/* <FormControl fullWidth variant="outlined"> */}
                  <Autocomplete
                    multiple
                    name="categoryItem"
                    options={categories}
                    getOptionLabel={(option) => option.name}
                    personName
                    onChange={handleAutoComplete}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Categories"
                        placeholder="Categories"
                        variant="outlined"
                        margin="normal"
                        fullWidth
                      />
                    )}
                  />
                  {/* </FormControl> */}
                </Grid>

                {/* Row 3 */}
                <Grid item xs={4} md={4}>
                  <Autocomplete
                    id="consultants-select"
                    options={staff?.data || []}
                    getOptionLabel={(option) => option?.name || ""}
                    value={staff?.data?.find((s) => s.id === searchData?.consultants) || null}
                    onChange={(event, newValue) => {
                      setSearchData({
                        ...searchData,
                        consultants: newValue ? newValue.id : "",
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Consultants"
                        variant="outlined"
                        placeholder="Select Consultant"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={4} md={4}>
                  <Autocomplete
                    id="specialty-select"
                    options={speciality?.data || []}
                    getOptionLabel={(option) => option?.speciality_name || ""}
                    value={speciality?.data?.find((s) => s.id === searchData?.specialty) || null}
                    onChange={(event, newValue) => {
                      setSearchData({
                        ...searchData,
                        specialty: newValue ? newValue.id : "",
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Specialty"
                        variant="outlined"
                        placeholder="Select Specialty"
                        fullWidth
                      />
                    )}
                  />
                </Grid>

                {/* Row 4: Dates */}
                <Grid item xs={4} md={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Date From"
                      variant="outlined"
                      value={searchData?.start_date || null}
                      onChange={(v) => setSearchData({ ...searchData, start_date: v })}
                      renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={4} md={6}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Date To"
                      variant="outlined"
                      value={searchData?.end_date || null}
                      onChange={(v) => setSearchData({ ...searchData, end_date: v })}
                      renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
                    />
                  </LocalizationProvider>
                </Grid>

                {/* Row 5: Buttons */}
                <Grid item xs={12}>
                  <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button variant="contained" color="secondary" onClick={handleDownload}>
                      Download
                    </Button>
                    <Button variant="contained" color="secondary" onClick={handleReset}>
                      Reset
                    </Button>
                    <Button variant="contained" color="secondary" onClick={handleClickSave}>
                      Save
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleClickSearch}>
                      Search
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </Menu>

          {((loginUserInfo?.role === "STAFF" &&
            loginUserInfo?.permissions?.some(p => p.toLowerCase() === "candidate-create")) || (loginUserInfo?.role !== "STAFF")) && (
              <Button
                color="primary"
                variant="contained"
                onClick={() => navigate(`${match.url}/create`)}
              >
                <AddIcon className="mr-2" />
                Add Candidate
              </Button>
            )}

          <EnhancedTableToolbar
            numSelected={0}
            visibleColumns={visibleColumns}
            handleColumnToggle={handleColumnToggle}
            headCells={headCells[0]}
          />
        </div>
      </Box >

      <Paper className={`${classes.root} mb-4`} >

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table">
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={(event, property) => {
                handleRequestSort(
                  property,
                  setOrder,
                  setOrderBy,
                  orderBy,
                  order
                );
              }}
              handleCheckboxAllClick={handleCheckboxAllClick}
              customerCount={customerCount?.length}
              rowCount={getSigneeItem?.data?.data?.length}
              headCells={headCells[0]}
              visibleColumns={visibleColumns}
            />

            <TableBody>
              {getSigneeItem?.data?.data &&
                getSigneeItem?.data?.data.map((list, index) => {
                  let category = categories?.filter((item) => list?.categories?.includes(item?.id)).map((item) => item?.name).join(", ");
                  let specialities = speciality?.filter((item) => list?.speciality_ids?.includes(item?.id)).map((item) => item?.speciality_name).join(", ");
                  let address = `${list?.address}`;
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" className="stickyCell stickyFirstrst" style={{ color: theme.palette.listItem }}>
                        <Checkbox
                          value={list.id}
                          checked={customerCount.includes(list.id)}
                          onClick={(event) =>
                            handleCheckboxClick(event, list.id)
                          }
                          style={{ color: theme.palette.listItem }}
                          className="selectCheckbox"
                        />
                      </TableCell>
                      {headCells[0]
                        .filter((col) => visibleColumns.includes(col.id))
                        .map((col, colIndex) => {
                          let cellValue = list[col.id];

                          // 🔹 Special formatting for certain columns
                          if (col.id === "id") {
                            cellValue = <Typography className={classes.cellId}>{cellValue}</Typography>;
                          }


                          if (col.id === "first_name") {
                            cellValue = (
                              <MuiLink
                                component={
                                  (loginUserInfo?.role === "STAFF" &&
                                    loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "candidate-view")) ||
                                    loginUserInfo?.role !== "STAFF" ? RouterLink : "span"
                                }
                                to="#"
                                onClick={(e) => {
                                  if ((loginUserInfo?.role === "STAFF" &&
                                    loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "candidate-view")) ||
                                    loginUserInfo?.role !== "STAFF") {
                                    e.preventDefault();
                                    onhandlClick(list.id);
                                  } else {
                                    e.preventDefault();
                                  }
                                }}
                                underline="hover"
                                sx={{
                                  cursor: (loginUserInfo?.role === "STAFF" &&
                                    loginUserInfo?.permissions?.some((p) => p.toLowerCase() === "candidate-view")) || (loginUserInfo?.role !== "STAFF") ? "pointer" : "not-allowed",
                                  color: "#3e81c3"
                                }}
                                className="clickableLink"
                              >
                                {list.first_name}  {list.last_name}
                              </MuiLink>
                            );
                          }
                          // 🔹 Generic DATE formatting (for all *_date columns)
                          // THIS IS COMMON CODE FOR ALL TYPE OF DATE
                          // if (col.id.toLowerCase().includes("date")) {
                          //   // cellValue = moment(list[col.id]).isValid() ? moment(list[col.id]).format("DD-MMM-YYYY").toUpperCase() : "-";
                          //   cellValue = moment(list[col.id]).isValid() ? moment(list[col.id]).format("DD-MMM-YYYY") : "-";
                          // }

                          if (col.id === "categories") {
                            cellValue = <TruncateText text={category} maxLength={8} />;
                          }

                          if (col.id === "speciality_ids") {
                            cellValue = <TruncateText text={specialities} maxLength={8} />;
                          }

                          if (col.id === "address") {
                            cellValue = <TruncateText text={address} maxLength={8} />;
                          }

                          if (col.id === "id_badge_exp_date") {
                            // const raw = list.id_badge_exp_date?.toString().trim() || "";
                            // // Parse with DD-MM-YYYY format
                            // const m = moment(raw, "DD-MM-YYYY", true);

                            // const isValid = m.isValid();
                            // const formatted = isValid ? m.format("DD MMM YYYY") : "-";
                            const formatted = convertDateFormat(list?.id_badge_exp_date);
                            cellValue = <span style={{
                              padding: list.id_badge_exp_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.id_badge_exp_date == null ? 'WHITE' : list?.id_badge_ex_date]
                            }}>{formatted}</span>;
                          }

                          if (col.id === "accessni_expiry_date") {
                            const formatted = convertDateFormat(list?.accessni_exp_date);
                            // // const formatted = moment(list.id_badge_exp_date, "DD-MM-YYYY").format("DD MMM YYYY");
                            cellValue = <span style={{
                              padding: list?.accessni_exp_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.accessni_exp_date == null ? 'WHITE' : list?.accessni_ex_date]
                            }}>{formatted}</span>;

                            // const formatted = moment(list.accessni_exp_date).isValid()
                            //   ? moment(list.accessni_exp_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.accessni_ex_date }}>{formatted}</span>;
                          }
                          if (col.id === "dbs_expire_date") {
                            // const formatted = moment(list.dbs_expire_date).isValid()
                            //   ? moment(list.dbs_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.db_expire_date }}>{formatted}</span>;
                            const formatted = convertDateFormat(list?.dbs_expire_date);
                            cellValue = <span style={{
                              padding: list.dbs_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.dbs_expire_date == null ? 'WHITE' : list?.db_expire_date]
                            }}>{formatted}</span>;
                          }
                          if (col.id === "fit_expire_date") {
                            // const formatted = moment(list.fit_expire_date).isValid()
                            //   ? moment(list.fit_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.ft_expire_date }}>{formatted}</span>;

                            const formatted = convertDateFormat(list?.fit_expire_date);
                            cellValue = <span style={{
                              padding: list.fit_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.fit_expire_date == null ? 'WHITE' : list?.ft_expire_date]
                            }}>{formatted}</span>;
                          }
                          if (col.id === "passport_expire_date") {
                            // const formatted = moment(list.passport_expire_date).isValid()
                            //   ? moment(list.passport_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.pass_expire_date }}>{formatted}</span>;

                            const formatted = convertDateFormat(list?.passport_expire_date);
                            cellValue = <span style={{
                              padding: list.passport_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.passport_expire_date == null ? 'WHITE' : list?.pass_expire_date]
                            }}>{formatted}</span>;
                          }
                          if (col.id === "nmc_expire_date") {
                            // const formatted = moment(list.nmc_expire_date).isValid()
                            //   ? moment(list.nmc_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.nm_expire_date }}>{formatted}</span>;

                            const formatted = convertDateFormat(list?.nmc_expire_date);
                            cellValue = <span style={{
                              padding: list.nmc_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.nmc_expire_date == null ? 'WHITE' : list?.nm_expire_date]
                            }}>{formatted}</span>;
                          }
                          if (col.id === "mandotoryt_expire_date") {
                            // const formatted = moment(list.mandotoryt_expire_date).isValid()
                            //   ? moment(list.mandotoryt_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.mand_expire_date }}>{formatted}</span>;

                            const formatted = convertDateFormat(list?.mandotoryt_expire_date);
                            cellValue = <span style={{
                              padding: list.mandotoryt_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.mandotoryt_expire_date == null ? 'WHITE' : list?.mand_expire_date]
                            }}>{formatted}</span>;
                          }
                          if (col.id === "ref1_expire_date") {
                            // const formatted = moment(list.ref1_expire_date).isValid()
                            //   ? moment(list.ref1_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.ref_1_expire_date }}>{formatted}</span>;

                            const formatted = convertDateFormat(list?.ref1_expire_date);
                            cellValue = <span style={{
                              padding: list.ref1_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.ref1_expire_date == null ? 'WHITE' : list?.ref_1_expire_date]
                            }}>{formatted}</span>;
                          }
                          if (col.id === "ref2_expire_date") {
                            // const formatted = moment(list.ref2_expire_date).isValid()
                            //   ? moment(list.ref2_expire_date).format("DD-MMM-YYYY")
                            //   : "-";

                            // cellValue = <span style={{ color: list?.ref_2_expire_date }}>{formatted}</span>;

                            const formatted = convertDateFormat(list?.ref2_expire_date);
                            cellValue = <span style={{
                              padding: list.ref2_expire_date == null ? "6px 47px" : "6px 10px",
                              borderRadius: "4px",
                              width: "fit-content",
                              ...expiryColorStyles[list.ref2_expire_date == null ? 'WHITE' : list?.ref_2_expire_date]
                            }}>{formatted}</span>;
                          }
                          const stickyClass =
                            colIndex === 0 ? "stickyCell stickyFirst" :
                              colIndex === 1 ? "stickyCell stickySecond" : "";

                          return (
                            <TableCell key={col.id} align={col.align} className={stickyClass} style={{ color: theme.palette.listItem }}>
                              {cellValue ?? "-"}
                            </TableCell>
                          );
                        })}
                    </TableRow>
                  );
                })}

              {getSigneeItem?.data?.data.length === 0 || getSigneeItem?.length === 0 && (
                <TableRow>
                  <TableCell align="center" colSpan={visibleColumns.length}>
                    Sorry no record available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePaginationControls
          page={page}
          rowsPerPage={perPage}
          totalRecords={getSigneeItem?.data?.total}
          onPageChange={handleChangePage}
          handlePerPageChange={handlePerPageChange}
        />
      </Paper >
      <Dialog
        open={modelOpen}
        onClose={handleClose1}
        maxWidth="sm"
        fullWidth
        classes={{ paper: classes.dialogWidth }}
      >
        <form>
          {/* Title */}
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Send Message
            </Typography>
          </DialogTitle>

          <Divider />

          {/* Content */}
          <DialogContent dividers>
            {/* Subject */}
            <TextField
              margin="normal"
              id="subject"
              label="Subject"
              variant="outlined"
              name="subject"
              fullWidth
              helperText={
                formError.includes("err_subject")
                  ? "Please enter subject"
                  : ""
              }
              error={formError.includes("err_subject")}
              value={data?.subject || ""}
              onChange={handleChanges}
              required
            />

            {/* Customer Count */}
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ mt: 1, mb: 2 }}
            >
              You have <strong>{customerCount.length}</strong> customers selected.
            </Typography>

            {/* Message Body */}
            <TextField
              id="messageBody"
              label="Message Body"
              variant="outlined"
              multiline
              rows={6}
              name="messageBody"
              fullWidth
              helperText={
                formError.includes("err_messageBody")
                  ? "Please enter message body"
                  : ""
              }
              error={formError.includes("err_messageBody")}
              value={data?.messageBody || ""}
              onChange={handleChanges}
              required
            />
          </DialogContent>

          {/* Actions */}
          <DialogActions sx={{ pr: 3, pb: 2 }}>
            <Button onClick={handleClose1} color="primary" variant="outlined">
              Cancel
            </Button>
            <Button
              color="secondary"
              variant="contained"
              type="submit"
              onClick={(event) => sendMessage(event)}
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default ViewSignee;
